// import { LOGIN, LOGIN_SUCCESS } from './constants'

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (err) {
    // Ignore write errors.
  }
};

export const destroyState = () => {
  try {
    localStorage.removeItem("state");
  } catch (err) {}
};

/*
Problems with window.location.href
  - It reloads the site so the redux store gets destroyed.
  - Not standardize for navigation in react, bla bla.
  - Detroyes router history bla bla.

Temp fix is to use localStorage to save user3 and auth when window.location.href is changes.
Then apply middleware to rehydrate the redux store
*/
export const reHydrateStore = () => {
  // try {
  //   const data = loadState()
  //   if (data) {
  //       return {
  //         auth: data,
  //         user3: fromJS(data)
  //       };
  //   }
  //   return undefined;
  // }
  // catch(err) {
  // }
};

// Set timeout to maybe prevent blocking the eventloop? testing <-- didnt work as expected
export const localStorageMiddleware = ({ getState }) => {
  return (next) => (action) => {
    try {
      const result = next(action);
      // if ([ LOGIN, LOGIN_SUCCESS ].includes(result.type)) {
      //     localStorage.setItem("state", JSON.stringify(getState().user3.toJS()))
      // }
      return result;
    } catch (err) {
      return next(action);
    }
  };
};
